import { $$ } from './utils'

;(() => {
  const expandHiddenBlockItemsButtons = $$('.expand-hidden-block-items')

  if (expandHiddenBlockItemsButtons.length) {
    expandHiddenBlockItemsButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        $$('li.hidden', e.target.closest('ul')).forEach((li) => li.classList.remove('hidden'))
        e.target.closest('li').classList.add('hidden')
      })
    })
  }
})()
